import { RewardTab } from './RewardTab'
import { withRewardTab } from './withRewardTab'

const ConnectedRewardTab = withRewardTab(RewardTab)
export { ConnectedRewardTab as RewardTab }
